import $ from "jquery";
const PATH = "api:///v4/tokens";
const getToken = () => $.ajax({
    method: "GET",
    url: `${PATH}`,
});
const create = (request) => {
    const payload = Object.assign(Object.assign(Object.assign({ email: request.email, password: request.password }, (request.client_id && { client_id: request.client_id })), (request.scopes && { scopes: request.scopes })), (request.durationSeconds && {
        duration_seconds: request.durationSeconds,
    }));
    return $.ajax({
        type: "POST",
        url: `${PATH}`,
        data: JSON.stringify(payload),
        contentType: "application/json",
    });
};
const createForClient = (request) => {
    const payload = Object.assign(Object.assign({ client_id: request.client_id }, (request.scopes && { scopes: request.scopes })), (request.durationSeconds && {
        duration_seconds: request.durationSeconds,
    }));
    return $.ajax({
        type: "POST",
        url: `${PATH}`,
        data: JSON.stringify(payload),
        contentType: "application/json",
    });
};
const validate = (authCodeResponseValidateRequest, csrfToken, nonce) => {
    const headers = {
        "X-CSRF-TOKEN": csrfToken,
        "X-NONCE": nonce,
    };
    return $.ajax({
        type: "POST",
        url: `${PATH}/openid-connect/authorization-code-flow`,
        data: JSON.stringify(authCodeResponseValidateRequest),
        contentType: "application/json",
        headers,
    });
};
export default {
    getToken,
    create,
    createForClient,
    validate,
};
